import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownloadStatusFailed = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 25,
	fill: "none",
	viewBox: "0 0 25 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "red",
		d: "m12.327 16.421-4.27-4.269 1.054-1.084 2.466 2.465v-8.4h1.5v8.4l2.465-2.465 1.054 1.084-4.27 4.27Zm-5.693 3.712c-.505 0-.932-.175-1.282-.525a1.745 1.745 0 0 1-.525-1.283v-2.711h1.5v2.711c0 .077.032.148.096.212a.294.294 0 0 0 .211.096H18.02a.294.294 0 0 0 .211-.096.293.293 0 0 0 .097-.212v-2.711h1.5v2.711c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H6.634Z"
	})
});
export { SvgDownloadStatusFailed as ReactComponent };
